export default {
    language: {
        name: '简体中文'
    },
    nav: {
        Home: 'Home',
        Browse: 'Browse',
        Search: 'Search',
        Standards: 'Standards',
        History: 'History',
        Credit: 'Credit',
        WDCMSOP: 'WDCM SOP',
        WDCMProcedures: 'WDCM Procedures',
        CultureCollections: 'Culture Collections',
    },
    table: {
        NoDataAvailable: '无数据',
    },
    wdcmsop3: {
        Culturecollection: 'Culture collection',
        Address: 'Address',
        PhoneFax: 'Phone & Fax',
        Email: 'Email',
        Website: 'Website',
    },
    standards: {
        Standard: 'Standard',
        Handbook: 'Handbook of Culture Media for Food and Water Microbiology',
        Description: 'Description',
    },
    browse: {
        ByStandardMethod: 'By Standard Method',
        StandardID: 'Standard ID',
        Description: 'Description',
        BySpecies: 'By Species',
        ByWDCMNumber: 'By WDCM Number',
        ByCultureCollection: 'By Culture Collection',
        SpeciesType: 'Species Type',
        StandardMethodType: 'Standard Method Type',
        Bacteria: 'Bacteria',
        FilamentousFungiandYeasts: 'Filamentous Fungi and Yeasts',
        result1: 'There are ',
        result2: ' bacterial species recorded made up of ',
        result3: ' reference strains',
        result4: ' records',
        standard_id: 'Standard Id',
        description: 'Description',
        strainIds: 'WDCM Number',
        SpeciesName: 'Species Name',
    },
    home: {
        ReferenceStrainCatalogue: 'Reference Strain Catalogue',
        Cooperativeunit: 'Cooperative unit',
        ReferenceStrainCatalogue_desc: 'This catalogue was produced to enable broader and easier access to the reference strains listed by the ISO TC 34 SC 9 Joint Working Group 5 and by the Working Party on Culture Media of the International Committee on Food Microbiology and Hygiene (ICFMH-WPCM) in their publication Handbook of Culture Media for Food and Water Microbiology. It fulfils a need expressed by these bodies for a unique system of identifiers for strains recommended for use in quality assurance.',
        WDCMReferenceStrainscover: 'WDCM Reference Strains cover',
        Strains: 'Strains',
        Species: 'Species',
        CultureCollections: 'Culture Collections',
        ISOotherstandards: 'ISO and other standards',
        Culturemedia: 'Culture media',
        NewsEvents: 'News&Events',
        PDF: 'PDF',
        WORD: 'WORD',
        // : '',
    },
    search: {
        searchKey: 'searchKey',
        StandardID: 'Standard ID',
        Description: 'Description',
        WDCMNumber: 'WDCM Number',
        nodata: 'NO record matches your keyword(s)',
    }
}


// WEBPACK FOOTER //
// ./src/js/lang/zh.js